import React, { memo } from "react";
import type { IconProps } from "./_IconProps";


const FixedWings = ({ color }: IconProps) => (
  <svg width={"24px"} height={"15px"} viewBox="0 0 24 15">
    <g
      id="BO---Site-KML"
      transform="translate(-554.000000, -702.000000)"
      fill={color || "#FFFFFF"}
    >
      <g id="ic/drone-p-W" transform="translate(554.000000, 698.000000)">
        <polygon id="Rectangle-4" points="9 5 9 4 15 4 15 5"></polygon>
        <rect id="Rectangle-4" x="11" y="5" width="2" height="3"></rect>
        <path
          d="M9,8 L15,8 L15,15.9942017 C15,17.6542582 13.6534829,19 12,19 C10.3431458,19 9,17.6511841 9,15.9942017 L9,8 Z M12,13 C12.5522847,13 13,12.5522847 13,12 C13,11.4477153 12.5522847,11 12,11 C11.4477153,11 11,11.4477153 11,12 C11,12.5522847 11.4477153,13 12,13 Z"
          id="Combined-Shape"
        ></path>
        <path
          d="M24,13 L15,7 C15,7 15,17.7937726 15,16.5 C15,15.2062274 16.6674863,15.4847065 18.2703938,16.2025146 C19.8733013,16.9203227 24,19 24,19"
          id="Rectangle-5"
        ></path>
        <path
          d="M9,13 L5.88907464e-12,7 C5.88907464e-12,7 -3.98054236e-12,17.7937726 1.5872229e-12,16.5 C7.15496741e-12,15.2062274 1.66748628,15.4847065 3.27039377,16.2025146 C4.87330125,16.9203227 9,19 9,19"
          id="Rectangle-5"
          transform="translate(4.500000, 13.000000) scale(-1, 1) translate(-4.500000, -13.000000) "
        ></path>
        <path
          d="M12,10 C14.209139,10 16,10.6568542 16,9 C16,7.34314575 14.209139,6 12,6 C9.790861,6 8,7.34314575 8,9 C8,10.6568542 9.790861,10 12,10 Z"
          id="Oval-3"
        ></path>
      </g>
    </g>
  </svg>
);

export default memo(FixedWings);
